export default {
  DEFAULT_DURATION: 60,
  DEFAULT_NB_USAGES: 5,
  DEFAULT_VALUE_THRESHOLD: 2000
};
